import React from 'react';

import { T } from '../../../../common/locale/translate';

const single_price_pln = data =>
  data.price_pln ? `${Math.ceil(data.price_pln)} zł` : ' - ';

const single_price_eur = data =>
  data.price_eur ? `${Math.ceil(data.price_eur)} €` : ' - ';

const duble_price_pln = data =>
  data.price_total_pln ? `${Math.ceil(data.price_total_pln)} zł` : ' - ';

const duble_price_eur = data =>
  data.price_total_eur ? `${Math.ceil(data.price_total_eur)} €` : ' - ';

const people_count = data => data.adults_number + data.children_ages.length;

const Price = ({
  data,
  is_estimated,
  only_per_person,
  isPromotionPrice,
  discount,
  isLowestPrice,
  isAvailable,
  onClick,
  title
}) => (
  <div
    className={`price${onClick ? ' clickable' : ''}`}
    onClick={onClick}
    title={title}
  >
    {isAvailable &&
      isPromotionPrice &&
      !isLowestPrice && (
        <span className="promotion-price">{`-${discount}%`}</span>
      )}
    {isAvailable &&
      isPromotionPrice &&
      isLowestPrice && (
        <span className="promotion-price the-lowest">{T('cheapest')}</span>
      )}
    <p className="price-element">
      {is_estimated ? T('from') : ' '} <em>{single_price_pln(data)}</em> /{' '}
      {T('person_shortcut')}
    </p>
    <span className="total-price">
      {only_per_person
        ? `${single_price_eur(data)} / ${T('person_shortcut')}`
        : `${duble_price_pln(data)} (${duble_price_eur(data)}) / ${people_count(
            data
          )} ${T('person_shortcut')}`}
    </span>
  </div>
);

export default Price;



// WEBPACK FOOTER //
// ./app/javascript/common/components/price.js